'use client';

import { Grid } from '@mui/material';
import { useMe } from '@prismo-io/feature-auth/providers/me';
import type { FC } from 'react';
import type { TypeQuarkEnum } from '../../utils/type-quark-enum';
import { ItemListQuark, type ItemListQuarkT } from './item';
type Props = {
  type: TypeQuarkEnum;
  list: ItemListQuarkT[];
  userUrl: string;
};
export const QuarkList: FC<Props> = (props: Props) => {
  const {
    list,
    type,
    userUrl
  } = props;
  const me = useMe();
  const isMe = me && me.url === userUrl;
  return <Grid container gap={3} data-sentry-element="Grid" data-sentry-component="QuarkList" data-sentry-source-file="index.tsx">
      {list.map((it, index) => {
      const position = (index + 1).toString();
      return <ItemListQuark key={it.id} index={position} needBtn={!!isMe} item={{
        id: it.id,
        name: it.name,
        favorite: it.favorite
      }} type={type} isFavorite={!!it.favorite} />;
    })}
    </Grid>;
};